module.exports = __webpack_public_path__ + "static/media/emptyStateOffice.ae0a0b00.svg";